//import { get } from "lodash";
import FloodlightActivities from "@/pixels/providers/floodlightActivities";
import * as ERRORES from "@/config/constants/step-constants";

describe("FloodlightActivities", () => {
  let context;

  beforeEach(() => {
    context = {
      state: {
        responseOferta: {
          respuesta: {
            oferta: {
              montoMaximo: 1000
            }
          }
        }
      }
    };
    // Mock the necessary global objects and functions
    window.gtag = jest.fn();
    window.location.href = "http://localhost/";
  });

  afterEach(() => {
    // Clear the mocks after each test
    jest.clearAllMocks();
  });

  it("should call gtag with the correct parameters for init", () => {
    FloodlightActivities.init();
    expect(window.gtag).toHaveBeenCalledTimes(2);
  });

  it("should return true if window.gtag exists", () => {
    expect(FloodlightActivities.wait()).toBe(true);
  });

  it("should return false if window.gtag does not exist", () => {
    delete window.gtag;
    expect(FloodlightActivities.wait()).toBe(false);
  });

  it("should call gtag with the correct parameters for landing", () => {
    FloodlightActivities.landing();
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest0+standard"
    });
  });

  it("should call gtag with the correct parameters for paso1", () => {
    FloodlightActivities.paso1();
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest00+standard"
    });
  });

  it("should call gtag with the correct parameters for paso2", () => {
    FloodlightActivities.paso2();
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest000+standard"
    });
  });

  it("should call gtag with the correct parameters for paso3", () => {
    FloodlightActivities.paso3();
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest001+standard"
    });
  });

  it("should call gtag with the correct parameters for paso4", () => {
    FloodlightActivities.paso4(context);
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      u7: context.state.responseOferta.respuesta.oferta.montoMaximo,
      send_to: "DC-10031883/prest0/prest002+standard"
    });
  });

  it("should call gtag with the correct parameters for gracias", () => {
    FloodlightActivities.gracias(context);
    expect(window.gtag).toHaveBeenCalledWith("event", "purchase", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      u7: context.state.responseOferta.respuesta.oferta.montoMaximo,
      send_to: "DC-10031883/prest000/prest0+transactions"
    });
  });

  it("should call gtag with the correct parameters for mensaje with ERROR_TECNICO", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: ERRORES.ERROR_TECNICO
          }
        }
      }
    };
    FloodlightActivities.mensaje(context);
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest004+standard"
    });
  });

  it("should call gtag with the correct parameters for mensaje with INDIVIDUO_NEGATIVO", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: ERRORES.INDIVIDUO_NEGATIVO
          }
        }
      }
    };
    FloodlightActivities.mensaje(context);
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest005+standard"
    });
  });

  it("should call gtag with the correct parameters for mensaje with default case", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: "OTHER_CASE"
          }
        }
      }
    };
    FloodlightActivities.mensaje(context);
    expect(window.gtag).toHaveBeenCalledWith("event", "conversion", {
      allow_custom_scripts: true,
      u3: "http://localhost/",
      send_to: "DC-10031883/prest0/prest003+standard"
    });
  });
});
